export default __webpack_public_path__ + "static/media/FluidStorage.256.b4245515.png";